import { createContext, useContext } from "react";


const filterInitialState = {
    productsList: [],
    onlyInStock: false,
    bestSellerOnly: false,
    sortBy: null,
    rating: null,
}

 const FilterContext = createContext(filterInitialState)

export const FilterProvider = ({children})=>{

    const ctxValue = {
        productsList: [1 , 2 , 3 , 4 , 5 , 6 , 7 , 8 , 9 , 10],
    }

return <FilterContext.Provider value={ctxValue}>
    {children}
</FilterContext.Provider>

}       

export const useFilter = ()=>{
    const context = useContext(FilterContext)
    return context
}

